var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center",staticStyle:{"position":"relative"},style:({height: _vm.height,width: _vm.width})},[_c('div',{ref:"grafica",staticStyle:{"height":"100%","width":"100%","position":"relative"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }